import { render, staticRenderFns } from "./ChooseNewPictrueZone.vue?vue&type=template&id=2d483458&scoped=true"
import script from "./ChooseNewPictrueZone.vue?vue&type=script&lang=js"
export * from "./ChooseNewPictrueZone.vue?vue&type=script&lang=js"
import style0 from "./ChooseNewPictrueZone.vue?vue&type=style&index=0&id=2d483458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d483458",
  null
  
)

export default component.exports